import {Lightbox} from "../../classes/Lightbox";

export const initComplexesAndSpots = () => {
	const complexesAndSpots = Array.from( document.querySelectorAll( 'section.cds2-complexes-and-spots' ) );

	if ( !complexesAndSpots.length )
	{
		return;
	}

	complexesAndSpots.forEach( ( it ) => {
		const cards = Array.from( it.querySelectorAll( 'ul.cards > li' ) );
		
		const adjustCards = () => {
			if ( window.innerWidth < 1024 && window.innerWidth > 635 )
			{
				cards.forEach( ( card ) => {
					card.removeAttribute( 'style' );
				} );
				
				cards.forEach( ( card, i ) => {
					if ( i - 2 < 0 )
					{
						return;
					}
					
					const currentCard = card;
					const previousCard = currentCard.previousElementSibling.previousElementSibling;
					const verticalDistance = currentCard.getBoundingClientRect().top - previousCard.getBoundingClientRect().bottom;

					if ( verticalDistance > 24 )
					{
						currentCard.style.top = ( verticalDistance - 24 ) * -1 + 'px'; 
					}
				} );
			}
			else
			{
				cards.forEach( ( card ) => {
					card.removeAttribute( 'style' );
				} );
			}
		};

		adjustCards();
		window.addEventListener( 'resize', adjustCards );
		
		const linksToComplexes = Array.from( it.querySelectorAll( 'a.card, div.spot-info ul a' ) );
		
		if ( linksToComplexes.length )
		{
			linksToComplexes.forEach( ( link ) => {
				link.addEventListener( 'click', ( evt ) => {
					if ( window.innerWidth > 1023 || evt.target.closest( 'h3' ) || window.innerWidth > 635 && link.classList.contains( 'card' ) )
					{
						return;
					}

					evt.preventDefault();

					const lightboxContent = document.createElement( 'a' );

					lightboxContent.classList.add( 'complex-card' );
					lightboxContent.href = link.href;
					if ( link.classList.contains( 'card' ) )
					{
						lightboxContent.innerHTML = link.innerHTML;
					}
					else
					{
						lightboxContent.innerHTML = link.querySelector( 'div.card' ).innerHTML;
						lightboxContent.classList.add( 'spot' );
					}
					
					Lightbox.open( lightboxContent, null, 'tooltip' );
				} );
			} );
		}
		
		const promotions = Array.from( it.querySelectorAll( 'ul.promotions.size-2' ) );

		if ( promotions.length )
		{
			promotions.forEach( ( it ) => {
				const priceItems = Array.from( it.querySelectorAll( 'li' ) );
				let currentItem = 0;
		
				priceItems.forEach( ( item, i ) => {
					if ( i === 0 )
					{
						return;
					}
		
					item.classList.add( 'hidden' );
				} );
		
				const changePrices = () => {
					priceItems[currentItem].classList.add( 'fading' );
					currentItem = currentItem < priceItems.length - 1 ? currentItem + 1 : 0;
					priceItems[currentItem].classList.remove( 'hidden' );
			
					const fadingTimeout = setTimeout( () => {
						const fadedItem = it.querySelector( 'li.fading' );
			
						fadedItem.classList.add( 'hidden' );
						fadedItem.classList.remove( 'fading' );
			
						clearTimeout( fadingTimeout );
					}, 500 );
				};
			
				setInterval( changePrices, 8000 );
			} );
		}

		const spots = Array.from( it.querySelectorAll( 'div.spot-info > ul' ) );

		if ( !spots.length )
		{
			return;
		}

		spots.forEach( ( it ) => {
			const spotItem = it.closest( 'li.spot' );
			
			it.addEventListener( 'mouseenter', () => {
				spotItem.classList.add( 'hovered' );
			} );
			
			it.addEventListener( 'mouseleave', () => {
				spotItem.classList.remove( 'hovered' );
			} );
		} );
	} );
};
